/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const GetEmployeesForLogbookDocument = gql`
    query GetEmployeesForLogbook($id: Int, $onlyActive: Boolean, $itemsPerPage: Int, $filterByNameAndPosition: Boolean, $companyId: Int!, $branchId: Int) {
  user(companyId: $companyId) {
    id
    company(id: $companyId) {
      id
      employees(
        id: $id
        onlyActive: $onlyActive
        itemsPerPage: $itemsPerPage
        filterByNameAndPosition: $filterByNameAndPosition
        branchId: $branchId
      ) {
        employees {
          id
          name
          surname
          email
          position {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetEmployeesForLogbookQuery__
 *
 * To run a query within a React component, call `useGetEmployeesForLogbookQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeesForLogbookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeesForLogbookQuery({
 *   variables: {
 *      id: // value for 'id'
 *      onlyActive: // value for 'onlyActive'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      filterByNameAndPosition: // value for 'filterByNameAndPosition'
 *      companyId: // value for 'companyId'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useGetEmployeesForLogbookQuery(baseOptions: Apollo.QueryHookOptions<GetEmployeesForLogbookQuery, GetEmployeesForLogbookQueryVariables> & ({ variables: GetEmployeesForLogbookQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeesForLogbookQuery, GetEmployeesForLogbookQueryVariables>(GetEmployeesForLogbookDocument, options);
      }
export function useGetEmployeesForLogbookLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeesForLogbookQuery, GetEmployeesForLogbookQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeesForLogbookQuery, GetEmployeesForLogbookQueryVariables>(GetEmployeesForLogbookDocument, options);
        }
export function useGetEmployeesForLogbookSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmployeesForLogbookQuery, GetEmployeesForLogbookQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEmployeesForLogbookQuery, GetEmployeesForLogbookQueryVariables>(GetEmployeesForLogbookDocument, options);
        }
export type GetEmployeesForLogbookQueryHookResult = ReturnType<typeof useGetEmployeesForLogbookQuery>;
export type GetEmployeesForLogbookLazyQueryHookResult = ReturnType<typeof useGetEmployeesForLogbookLazyQuery>;
export type GetEmployeesForLogbookSuspenseQueryHookResult = ReturnType<typeof useGetEmployeesForLogbookSuspenseQuery>;
export type GetEmployeesForLogbookQueryResult = Apollo.QueryResult<GetEmployeesForLogbookQuery, GetEmployeesForLogbookQueryVariables>;
export const GetServicesForLogbookDocument = gql`
    query GetServicesForLogbook($onlyFromBookings: Boolean, $itemsPerPage: Int, $companyId: Int!) {
  user(companyId: $companyId) {
    id
    company(id: $companyId) {
      id
      services(onlyFromBookings: $onlyFromBookings, itemsPerPage: $itemsPerPage) {
        itemsPerPage
        services {
          id
          name
          serviceCategoryNew {
            id
            name
            parentCategory {
              id
              name
              deleted
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetServicesForLogbookQuery__
 *
 * To run a query within a React component, call `useGetServicesForLogbookQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServicesForLogbookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServicesForLogbookQuery({
 *   variables: {
 *      onlyFromBookings: // value for 'onlyFromBookings'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetServicesForLogbookQuery(baseOptions: Apollo.QueryHookOptions<GetServicesForLogbookQuery, GetServicesForLogbookQueryVariables> & ({ variables: GetServicesForLogbookQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServicesForLogbookQuery, GetServicesForLogbookQueryVariables>(GetServicesForLogbookDocument, options);
      }
export function useGetServicesForLogbookLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServicesForLogbookQuery, GetServicesForLogbookQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServicesForLogbookQuery, GetServicesForLogbookQueryVariables>(GetServicesForLogbookDocument, options);
        }
export function useGetServicesForLogbookSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServicesForLogbookQuery, GetServicesForLogbookQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServicesForLogbookQuery, GetServicesForLogbookQueryVariables>(GetServicesForLogbookDocument, options);
        }
export type GetServicesForLogbookQueryHookResult = ReturnType<typeof useGetServicesForLogbookQuery>;
export type GetServicesForLogbookLazyQueryHookResult = ReturnType<typeof useGetServicesForLogbookLazyQuery>;
export type GetServicesForLogbookSuspenseQueryHookResult = ReturnType<typeof useGetServicesForLogbookSuspenseQuery>;
export type GetServicesForLogbookQueryResult = Apollo.QueryResult<GetServicesForLogbookQuery, GetServicesForLogbookQueryVariables>;
export const GetEmployeePositionsDocument = gql`
    query GetEmployeePositions($itemsPerPage: Int, $companyId: Int!) {
  user(companyId: $companyId) {
    id
    company(id: $companyId) {
      id
      employeePositions(itemsPerPage: $itemsPerPage) {
        employeePositions {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetEmployeePositionsQuery__
 *
 * To run a query within a React component, call `useGetEmployeePositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeePositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeePositionsQuery({
 *   variables: {
 *      itemsPerPage: // value for 'itemsPerPage'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetEmployeePositionsQuery(baseOptions: Apollo.QueryHookOptions<GetEmployeePositionsQuery, GetEmployeePositionsQueryVariables> & ({ variables: GetEmployeePositionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeePositionsQuery, GetEmployeePositionsQueryVariables>(GetEmployeePositionsDocument, options);
      }
export function useGetEmployeePositionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeePositionsQuery, GetEmployeePositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeePositionsQuery, GetEmployeePositionsQueryVariables>(GetEmployeePositionsDocument, options);
        }
export function useGetEmployeePositionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmployeePositionsQuery, GetEmployeePositionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEmployeePositionsQuery, GetEmployeePositionsQueryVariables>(GetEmployeePositionsDocument, options);
        }
export type GetEmployeePositionsQueryHookResult = ReturnType<typeof useGetEmployeePositionsQuery>;
export type GetEmployeePositionsLazyQueryHookResult = ReturnType<typeof useGetEmployeePositionsLazyQuery>;
export type GetEmployeePositionsSuspenseQueryHookResult = ReturnType<typeof useGetEmployeePositionsSuspenseQuery>;
export type GetEmployeePositionsQueryResult = Apollo.QueryResult<GetEmployeePositionsQuery, GetEmployeePositionsQueryVariables>;
export const GetBookingStatusForLogbookDocument = gql`
    query GetBookingStatusForLogbook {
  bookingStatus {
    id
    name
  }
}
    `;

/**
 * __useGetBookingStatusForLogbookQuery__
 *
 * To run a query within a React component, call `useGetBookingStatusForLogbookQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingStatusForLogbookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingStatusForLogbookQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBookingStatusForLogbookQuery(baseOptions?: Apollo.QueryHookOptions<GetBookingStatusForLogbookQuery, GetBookingStatusForLogbookQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingStatusForLogbookQuery, GetBookingStatusForLogbookQueryVariables>(GetBookingStatusForLogbookDocument, options);
      }
export function useGetBookingStatusForLogbookLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingStatusForLogbookQuery, GetBookingStatusForLogbookQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingStatusForLogbookQuery, GetBookingStatusForLogbookQueryVariables>(GetBookingStatusForLogbookDocument, options);
        }
export function useGetBookingStatusForLogbookSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBookingStatusForLogbookQuery, GetBookingStatusForLogbookQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBookingStatusForLogbookQuery, GetBookingStatusForLogbookQueryVariables>(GetBookingStatusForLogbookDocument, options);
        }
export type GetBookingStatusForLogbookQueryHookResult = ReturnType<typeof useGetBookingStatusForLogbookQuery>;
export type GetBookingStatusForLogbookLazyQueryHookResult = ReturnType<typeof useGetBookingStatusForLogbookLazyQuery>;
export type GetBookingStatusForLogbookSuspenseQueryHookResult = ReturnType<typeof useGetBookingStatusForLogbookSuspenseQuery>;
export type GetBookingStatusForLogbookQueryResult = Apollo.QueryResult<GetBookingStatusForLogbookQuery, GetBookingStatusForLogbookQueryVariables>;
export const GetCurrentEmployeeIdDocument = gql`
    query GetCurrentEmployeeId($companyId: Int!) {
  user(companyId: $companyId) {
    id
    employee(companyId: $companyId) {
      id
      name
    }
  }
}
    `;

/**
 * __useGetCurrentEmployeeIdQuery__
 *
 * To run a query within a React component, call `useGetCurrentEmployeeIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentEmployeeIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentEmployeeIdQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetCurrentEmployeeIdQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentEmployeeIdQuery, GetCurrentEmployeeIdQueryVariables> & ({ variables: GetCurrentEmployeeIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentEmployeeIdQuery, GetCurrentEmployeeIdQueryVariables>(GetCurrentEmployeeIdDocument, options);
      }
export function useGetCurrentEmployeeIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentEmployeeIdQuery, GetCurrentEmployeeIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentEmployeeIdQuery, GetCurrentEmployeeIdQueryVariables>(GetCurrentEmployeeIdDocument, options);
        }
export function useGetCurrentEmployeeIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentEmployeeIdQuery, GetCurrentEmployeeIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentEmployeeIdQuery, GetCurrentEmployeeIdQueryVariables>(GetCurrentEmployeeIdDocument, options);
        }
export type GetCurrentEmployeeIdQueryHookResult = ReturnType<typeof useGetCurrentEmployeeIdQuery>;
export type GetCurrentEmployeeIdLazyQueryHookResult = ReturnType<typeof useGetCurrentEmployeeIdLazyQuery>;
export type GetCurrentEmployeeIdSuspenseQueryHookResult = ReturnType<typeof useGetCurrentEmployeeIdSuspenseQuery>;
export type GetCurrentEmployeeIdQueryResult = Apollo.QueryResult<GetCurrentEmployeeIdQuery, GetCurrentEmployeeIdQueryVariables>;
export const GetBookingsListDocument = gql`
    query GetBookingsList($branchId: Int, $isDeleted: Boolean, $startDate: String, $endDate: String, $statusId: Int, $serviceId: Int, $companyId: Int!, $employeeId: Int, $positionId: Int) {
  user(companyId: $companyId) {
    id
    company(id: $companyId) {
      id
      employees(id: $employeeId) {
        employees {
          tariffBlocking
        }
      }
      employeesList(positionId: $positionId) {
        id
      }
      branches(id: $branchId, isDeleted: $isDeleted) {
        bookingsList(
          startDate: $startDate
          endDate: $endDate
          statusId: $statusId
          serviceId: $serviceId
        ) {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetBookingsListQuery__
 *
 * To run a query within a React component, call `useGetBookingsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingsListQuery({
 *   variables: {
 *      branchId: // value for 'branchId'
 *      isDeleted: // value for 'isDeleted'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      statusId: // value for 'statusId'
 *      serviceId: // value for 'serviceId'
 *      companyId: // value for 'companyId'
 *      employeeId: // value for 'employeeId'
 *      positionId: // value for 'positionId'
 *   },
 * });
 */
export function useGetBookingsListQuery(baseOptions: Apollo.QueryHookOptions<GetBookingsListQuery, GetBookingsListQueryVariables> & ({ variables: GetBookingsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingsListQuery, GetBookingsListQueryVariables>(GetBookingsListDocument, options);
      }
export function useGetBookingsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingsListQuery, GetBookingsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingsListQuery, GetBookingsListQueryVariables>(GetBookingsListDocument, options);
        }
export function useGetBookingsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBookingsListQuery, GetBookingsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBookingsListQuery, GetBookingsListQueryVariables>(GetBookingsListDocument, options);
        }
export type GetBookingsListQueryHookResult = ReturnType<typeof useGetBookingsListQuery>;
export type GetBookingsListLazyQueryHookResult = ReturnType<typeof useGetBookingsListLazyQuery>;
export type GetBookingsListSuspenseQueryHookResult = ReturnType<typeof useGetBookingsListSuspenseQuery>;
export type GetBookingsListQueryResult = Apollo.QueryResult<GetBookingsListQuery, GetBookingsListQueryVariables>;
export const GetBookingByIdDocument = gql`
    query GetBookingById($branchId: Int, $bookingId: Int, $companyId: Int!) {
  user(companyId: $companyId) {
    id
    company(id: $companyId) {
      id
      branches(id: $branchId) {
        bookings(id: $bookingId) {
          bookings {
            date
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetBookingByIdQuery__
 *
 * To run a query within a React component, call `useGetBookingByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingByIdQuery({
 *   variables: {
 *      branchId: // value for 'branchId'
 *      bookingId: // value for 'bookingId'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetBookingByIdQuery(baseOptions: Apollo.QueryHookOptions<GetBookingByIdQuery, GetBookingByIdQueryVariables> & ({ variables: GetBookingByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingByIdQuery, GetBookingByIdQueryVariables>(GetBookingByIdDocument, options);
      }
export function useGetBookingByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingByIdQuery, GetBookingByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingByIdQuery, GetBookingByIdQueryVariables>(GetBookingByIdDocument, options);
        }
export function useGetBookingByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBookingByIdQuery, GetBookingByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBookingByIdQuery, GetBookingByIdQueryVariables>(GetBookingByIdDocument, options);
        }
export type GetBookingByIdQueryHookResult = ReturnType<typeof useGetBookingByIdQuery>;
export type GetBookingByIdLazyQueryHookResult = ReturnType<typeof useGetBookingByIdLazyQuery>;
export type GetBookingByIdSuspenseQueryHookResult = ReturnType<typeof useGetBookingByIdSuspenseQuery>;
export type GetBookingByIdQueryResult = Apollo.QueryResult<GetBookingByIdQuery, GetBookingByIdQueryVariables>;
export const CheckBranchDataForLogBookDocument = gql`
    query CheckBranchDataForLogBook($companyId: Int!, $branchId: Int!, $bookingsLimit: Int) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      branches(id: $branchId) {
        isAnyActiveServiceEmployeeRelations
        isAnyActiveServices
        isAnyWorkScheduleForWorkingEmployees
        id
        bookingsList(limit: $bookingsLimit) {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useCheckBranchDataForLogBookQuery__
 *
 * To run a query within a React component, call `useCheckBranchDataForLogBookQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckBranchDataForLogBookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckBranchDataForLogBookQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      branchId: // value for 'branchId'
 *      bookingsLimit: // value for 'bookingsLimit'
 *   },
 * });
 */
export function useCheckBranchDataForLogBookQuery(baseOptions: Apollo.QueryHookOptions<CheckBranchDataForLogBookQuery, CheckBranchDataForLogBookQueryVariables> & ({ variables: CheckBranchDataForLogBookQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckBranchDataForLogBookQuery, CheckBranchDataForLogBookQueryVariables>(CheckBranchDataForLogBookDocument, options);
      }
export function useCheckBranchDataForLogBookLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckBranchDataForLogBookQuery, CheckBranchDataForLogBookQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckBranchDataForLogBookQuery, CheckBranchDataForLogBookQueryVariables>(CheckBranchDataForLogBookDocument, options);
        }
export function useCheckBranchDataForLogBookSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckBranchDataForLogBookQuery, CheckBranchDataForLogBookQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckBranchDataForLogBookQuery, CheckBranchDataForLogBookQueryVariables>(CheckBranchDataForLogBookDocument, options);
        }
export type CheckBranchDataForLogBookQueryHookResult = ReturnType<typeof useCheckBranchDataForLogBookQuery>;
export type CheckBranchDataForLogBookLazyQueryHookResult = ReturnType<typeof useCheckBranchDataForLogBookLazyQuery>;
export type CheckBranchDataForLogBookSuspenseQueryHookResult = ReturnType<typeof useCheckBranchDataForLogBookSuspenseQuery>;
export type CheckBranchDataForLogBookQueryResult = Apollo.QueryResult<CheckBranchDataForLogBookQuery, CheckBranchDataForLogBookQueryVariables>;
export const GetCurrentBranchForNotificationsDocument = gql`
    query getCurrentBranchForNotifications($companyId: Int!, $branchId: Int!, $bookingsLimit: Int) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      branches(id: $branchId) {
        isAnyActiveServiceEmployeeRelations
        isAnyActiveServices
        isAnyWorkScheduleForWorkingEmployees
        id
        bookingsList(limit: $bookingsLimit) {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetCurrentBranchForNotificationsQuery__
 *
 * To run a query within a React component, call `useGetCurrentBranchForNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentBranchForNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentBranchForNotificationsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      branchId: // value for 'branchId'
 *      bookingsLimit: // value for 'bookingsLimit'
 *   },
 * });
 */
export function useGetCurrentBranchForNotificationsQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentBranchForNotificationsQuery, GetCurrentBranchForNotificationsQueryVariables> & ({ variables: GetCurrentBranchForNotificationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentBranchForNotificationsQuery, GetCurrentBranchForNotificationsQueryVariables>(GetCurrentBranchForNotificationsDocument, options);
      }
export function useGetCurrentBranchForNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentBranchForNotificationsQuery, GetCurrentBranchForNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentBranchForNotificationsQuery, GetCurrentBranchForNotificationsQueryVariables>(GetCurrentBranchForNotificationsDocument, options);
        }
export function useGetCurrentBranchForNotificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentBranchForNotificationsQuery, GetCurrentBranchForNotificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentBranchForNotificationsQuery, GetCurrentBranchForNotificationsQueryVariables>(GetCurrentBranchForNotificationsDocument, options);
        }
export type GetCurrentBranchForNotificationsQueryHookResult = ReturnType<typeof useGetCurrentBranchForNotificationsQuery>;
export type GetCurrentBranchForNotificationsLazyQueryHookResult = ReturnType<typeof useGetCurrentBranchForNotificationsLazyQuery>;
export type GetCurrentBranchForNotificationsSuspenseQueryHookResult = ReturnType<typeof useGetCurrentBranchForNotificationsSuspenseQuery>;
export type GetCurrentBranchForNotificationsQueryResult = Apollo.QueryResult<GetCurrentBranchForNotificationsQuery, GetCurrentBranchForNotificationsQueryVariables>;
export const GetEmployeesNotInBranchForLogbookDocument = gql`
    query getEmployeesNotInBranchForLogbook($companyId: Int!, $excludeBranchId: Int!) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      employeesNotInBranch(excludeBranchId: $excludeBranchId) {
        id
        name
        surname
        image
        userBranchRelations {
          id
          branch {
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetEmployeesNotInBranchForLogbookQuery__
 *
 * To run a query within a React component, call `useGetEmployeesNotInBranchForLogbookQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeesNotInBranchForLogbookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeesNotInBranchForLogbookQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      excludeBranchId: // value for 'excludeBranchId'
 *   },
 * });
 */
export function useGetEmployeesNotInBranchForLogbookQuery(baseOptions: Apollo.QueryHookOptions<GetEmployeesNotInBranchForLogbookQuery, GetEmployeesNotInBranchForLogbookQueryVariables> & ({ variables: GetEmployeesNotInBranchForLogbookQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeesNotInBranchForLogbookQuery, GetEmployeesNotInBranchForLogbookQueryVariables>(GetEmployeesNotInBranchForLogbookDocument, options);
      }
export function useGetEmployeesNotInBranchForLogbookLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeesNotInBranchForLogbookQuery, GetEmployeesNotInBranchForLogbookQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeesNotInBranchForLogbookQuery, GetEmployeesNotInBranchForLogbookQueryVariables>(GetEmployeesNotInBranchForLogbookDocument, options);
        }
export function useGetEmployeesNotInBranchForLogbookSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmployeesNotInBranchForLogbookQuery, GetEmployeesNotInBranchForLogbookQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEmployeesNotInBranchForLogbookQuery, GetEmployeesNotInBranchForLogbookQueryVariables>(GetEmployeesNotInBranchForLogbookDocument, options);
        }
export type GetEmployeesNotInBranchForLogbookQueryHookResult = ReturnType<typeof useGetEmployeesNotInBranchForLogbookQuery>;
export type GetEmployeesNotInBranchForLogbookLazyQueryHookResult = ReturnType<typeof useGetEmployeesNotInBranchForLogbookLazyQuery>;
export type GetEmployeesNotInBranchForLogbookSuspenseQueryHookResult = ReturnType<typeof useGetEmployeesNotInBranchForLogbookSuspenseQuery>;
export type GetEmployeesNotInBranchForLogbookQueryResult = Apollo.QueryResult<GetEmployeesNotInBranchForLogbookQuery, GetEmployeesNotInBranchForLogbookQueryVariables>;
export const GetTimeZoneForLogbookDocument = gql`
    query getTimeZoneForLogbook($companyId: Int!) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      timeZone {
        name
      }
    }
  }
}
    `;

/**
 * __useGetTimeZoneForLogbookQuery__
 *
 * To run a query within a React component, call `useGetTimeZoneForLogbookQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimeZoneForLogbookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimeZoneForLogbookQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetTimeZoneForLogbookQuery(baseOptions: Apollo.QueryHookOptions<GetTimeZoneForLogbookQuery, GetTimeZoneForLogbookQueryVariables> & ({ variables: GetTimeZoneForLogbookQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTimeZoneForLogbookQuery, GetTimeZoneForLogbookQueryVariables>(GetTimeZoneForLogbookDocument, options);
      }
export function useGetTimeZoneForLogbookLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimeZoneForLogbookQuery, GetTimeZoneForLogbookQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTimeZoneForLogbookQuery, GetTimeZoneForLogbookQueryVariables>(GetTimeZoneForLogbookDocument, options);
        }
export function useGetTimeZoneForLogbookSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTimeZoneForLogbookQuery, GetTimeZoneForLogbookQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTimeZoneForLogbookQuery, GetTimeZoneForLogbookQueryVariables>(GetTimeZoneForLogbookDocument, options);
        }
export type GetTimeZoneForLogbookQueryHookResult = ReturnType<typeof useGetTimeZoneForLogbookQuery>;
export type GetTimeZoneForLogbookLazyQueryHookResult = ReturnType<typeof useGetTimeZoneForLogbookLazyQuery>;
export type GetTimeZoneForLogbookSuspenseQueryHookResult = ReturnType<typeof useGetTimeZoneForLogbookSuspenseQuery>;
export type GetTimeZoneForLogbookQueryResult = Apollo.QueryResult<GetTimeZoneForLogbookQuery, GetTimeZoneForLogbookQueryVariables>;
export const GetCurrentBranchNameAndIdForRightModalDocument = gql`
    query getCurrentBranchNameAndIdForRightModal($companyId: Int!, $branchId: Int!) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      branches(id: $branchId) {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetCurrentBranchNameAndIdForRightModalQuery__
 *
 * To run a query within a React component, call `useGetCurrentBranchNameAndIdForRightModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentBranchNameAndIdForRightModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentBranchNameAndIdForRightModalQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useGetCurrentBranchNameAndIdForRightModalQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentBranchNameAndIdForRightModalQuery, GetCurrentBranchNameAndIdForRightModalQueryVariables> & ({ variables: GetCurrentBranchNameAndIdForRightModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentBranchNameAndIdForRightModalQuery, GetCurrentBranchNameAndIdForRightModalQueryVariables>(GetCurrentBranchNameAndIdForRightModalDocument, options);
      }
export function useGetCurrentBranchNameAndIdForRightModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentBranchNameAndIdForRightModalQuery, GetCurrentBranchNameAndIdForRightModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentBranchNameAndIdForRightModalQuery, GetCurrentBranchNameAndIdForRightModalQueryVariables>(GetCurrentBranchNameAndIdForRightModalDocument, options);
        }
export function useGetCurrentBranchNameAndIdForRightModalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentBranchNameAndIdForRightModalQuery, GetCurrentBranchNameAndIdForRightModalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentBranchNameAndIdForRightModalQuery, GetCurrentBranchNameAndIdForRightModalQueryVariables>(GetCurrentBranchNameAndIdForRightModalDocument, options);
        }
export type GetCurrentBranchNameAndIdForRightModalQueryHookResult = ReturnType<typeof useGetCurrentBranchNameAndIdForRightModalQuery>;
export type GetCurrentBranchNameAndIdForRightModalLazyQueryHookResult = ReturnType<typeof useGetCurrentBranchNameAndIdForRightModalLazyQuery>;
export type GetCurrentBranchNameAndIdForRightModalSuspenseQueryHookResult = ReturnType<typeof useGetCurrentBranchNameAndIdForRightModalSuspenseQuery>;
export type GetCurrentBranchNameAndIdForRightModalQueryResult = Apollo.QueryResult<GetCurrentBranchNameAndIdForRightModalQuery, GetCurrentBranchNameAndIdForRightModalQueryVariables>;
export type GetEmployeesForLogbookQueryVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  onlyActive?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  itemsPerPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  filterByNameAndPosition?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  companyId: Types.Scalars['Int']['input'];
  branchId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetEmployeesForLogbookQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, company?: { __typename?: 'CompanyProxy', id: number, employees?: { __typename?: 'EmployeePaginated', employees?: Array<{ __typename?: 'EmployeeProxy', id: number, name?: string | null, surname?: string | null, email: string, position?: { __typename?: 'EmployeePositionProxy', id: number, name: string } | null }> | null } | null } | null } | null };

export type GetServicesForLogbookQueryVariables = Types.Exact<{
  onlyFromBookings?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  itemsPerPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  companyId: Types.Scalars['Int']['input'];
}>;


export type GetServicesForLogbookQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, company?: { __typename?: 'CompanyProxy', id: number, services?: { __typename?: 'ServicePaginated', itemsPerPage?: number | null, services?: Array<{ __typename?: 'ServiceProxy', id: number, name: string, serviceCategoryNew?: { __typename?: 'ServiceCategoryNewProxy', id: number, name: string, parentCategory?: { __typename?: 'ServiceCategoryNewProxy', id: number, name: string, deleted: boolean } | null } | null }> | null } | null } | null } | null };

export type GetEmployeePositionsQueryVariables = Types.Exact<{
  itemsPerPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  companyId: Types.Scalars['Int']['input'];
}>;


export type GetEmployeePositionsQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, company?: { __typename?: 'CompanyProxy', id: number, employeePositions?: { __typename?: 'EmployeePositionPaginated', employeePositions?: Array<{ __typename?: 'EmployeePositionProxy', id: number, name: string }> | null } | null } | null } | null };

export type GetBookingStatusForLogbookQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetBookingStatusForLogbookQuery = { __typename?: 'Query', bookingStatus: Array<{ __typename?: 'BookingStatusProxy', id: number, name: string }> };

export type GetCurrentEmployeeIdQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
}>;


export type GetCurrentEmployeeIdQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, employee?: { __typename?: 'EmployeeProxy', id: number, name?: string | null } | null } | null };

export type GetBookingsListQueryVariables = Types.Exact<{
  branchId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  isDeleted?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  startDate?: Types.InputMaybe<Types.Scalars['String']['input']>;
  endDate?: Types.InputMaybe<Types.Scalars['String']['input']>;
  statusId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  serviceId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  companyId: Types.Scalars['Int']['input'];
  employeeId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  positionId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetBookingsListQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, company?: { __typename?: 'CompanyProxy', id: number, employees?: { __typename?: 'EmployeePaginated', employees?: Array<{ __typename?: 'EmployeeProxy', tariffBlocking: boolean }> | null } | null, employeesList?: Array<{ __typename?: 'EmployeeProxy', id: number }> | null, branches?: Array<{ __typename?: 'BranchProxy', bookingsList?: Array<{ __typename?: 'BookingMainProxy', id: number }> | null }> | null } | null } | null };

export type GetBookingByIdQueryVariables = Types.Exact<{
  branchId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  bookingId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  companyId: Types.Scalars['Int']['input'];
}>;


export type GetBookingByIdQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, company?: { __typename?: 'CompanyProxy', id: number, branches?: Array<{ __typename?: 'BranchProxy', bookings?: { __typename?: 'BookingPaginated', bookings?: Array<{ __typename?: 'BookingMainProxy', date?: string | null }> | null } | null }> | null } | null } | null };

export type CheckBranchDataForLogBookQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  branchId: Types.Scalars['Int']['input'];
  bookingsLimit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type CheckBranchDataForLogBookQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', branches?: Array<{ __typename?: 'BranchProxy', isAnyActiveServiceEmployeeRelations: boolean, isAnyActiveServices: boolean, isAnyWorkScheduleForWorkingEmployees: boolean, id: number, bookingsList?: Array<{ __typename?: 'BookingMainProxy', id: number }> | null }> | null } | null } | null };

export type GetCurrentBranchForNotificationsQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  branchId: Types.Scalars['Int']['input'];
  bookingsLimit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetCurrentBranchForNotificationsQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', branches?: Array<{ __typename?: 'BranchProxy', isAnyActiveServiceEmployeeRelations: boolean, isAnyActiveServices: boolean, isAnyWorkScheduleForWorkingEmployees: boolean, id: number, bookingsList?: Array<{ __typename?: 'BookingMainProxy', id: number }> | null }> | null } | null } | null };

export type GetEmployeesNotInBranchForLogbookQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  excludeBranchId: Types.Scalars['Int']['input'];
}>;


export type GetEmployeesNotInBranchForLogbookQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', employeesNotInBranch?: Array<{ __typename?: 'EmployeeProxy', id: number, name?: string | null, surname?: string | null, image?: string | null, userBranchRelations?: Array<{ __typename?: 'UserBranchRelationProxy', id: number, branch: { __typename?: 'BranchProxy', name: string } }> | null }> | null } | null } | null };

export type GetTimeZoneForLogbookQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
}>;


export type GetTimeZoneForLogbookQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', timeZone?: { __typename?: 'TimeZoneProxy', name: string } | null } | null } | null };

export type GetCurrentBranchNameAndIdForRightModalQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  branchId: Types.Scalars['Int']['input'];
}>;


export type GetCurrentBranchNameAndIdForRightModalQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', branches?: Array<{ __typename?: 'BranchProxy', id: number, name: string }> | null } | null } | null };
